<template>
  <div id="Admin_Payment">
    <!-- 標題 -->
    <v-title>
      <font-awesome-icon icon="hand-holding-usd" />
      繳款項目及退費
    </v-title>
    <hr>
    <!-- 內容 -->
    <div class="tab-content">
      <!-- 項目Tab -->
      <ul
        id="adminrefund"
        class="nav nav-tabs"
        role="tablist"
      >
        <li class="nav-item">
          <a
            id="areceipt_report"
            class="nav-link"
            :class="[isActive ? 'active' : '']"
            :href="'#/admin/refund/receipt_report'"
            @click="FeeorderList('true')"
            role="tab"
            aria-controls="areceipt_report"
            aria-selected="true"
          >
            繳款項目查詢及退費申請
          </a>
        </li>
        <li class="nav-item">
          <a
            v-if="Privilege.Privilege === '管理者'"
            id="arr"
            class="nav-link"
            :class="[isActives ? 'active' : '']"
            :href="'#/admin/refund/receipt'"
            @click="FeeorderList('false')"
            role="tab"
            aria-controls="areceipt"
            aria-selected="false"
          >
            現金繳納
          </a>
        </li>
      </ul>
      <ReceiptReport v-if="isActive" />
      <Receipt v-if="isActives" />
    </div>
    <br>
  </div>
</template>

<script>
import ReceiptReport from './Receipt_Report'
import Receipt from './Receipt'
export default {
  components: {
    ReceiptReport,
    Receipt
  },
  data () {
    return {
      Privilege: '',
      isActive: true,
      isActives: false
    }
  },
  mounted () {
    this.Privilege = JSON.parse(sessionStorage.getItem('UserData')) ? JSON.parse(sessionStorage.getItem('UserData')) : 'false'
  },
  methods: {
    FeeorderList (data) { // 觸發切換頁籤
      const vm = this
      if (data === 'true') {
        vm.isActive = true
        vm.isActives = false
      } else {
        vm.isActive = false
        vm.isActives = true
      }
    }
  }
}
</script>
